import _ from 'underscore';
import Backbone from '@trello/backbone';

type TriggerableAjaxEvent = 'connecting' | 'connect_failed' | 'reconnect';
type ListenableAjaxEvent = TriggerableAjaxEvent | 'all';

type BackboneEvents = typeof Backbone.Events;
interface AjaxEvents extends BackboneEvents {
  trigger(
    name: TriggerableAjaxEvent,
    data?: object | string,
    idModel?: string,
    tags?: string[],
  ): this;
  listenTo(
    context: this,
    name: ListenableAjaxEvent,
    callback: (name: TriggerableAjaxEvent, data?: object | string) => void,
  ): this;
}

export const ajaxEvents: AjaxEvents = _.extend({}, Backbone.Events);
